export const isNearConversationEnd = (element) =>
  element.scrollHeight - element.clientHeight - element.scrollTop <= 80;

export const mergeMessages = (current, incoming) => {
  const byId = new Map(current.map((message) => [message.id, message]));
  incoming.forEach((message) => {
    const existing = byId.get(message.id);
    if (!existing) {
      byId.set(message.id, message);
      return;
    }

    const existingTime = new Date(
      existing.updatedAt || existing.createdAt || 0,
    ).getTime();
    const incomingTime = new Date(
      message.updatedAt || message.createdAt || 0,
    ).getTime();
    byId.set(
      message.id,
      incomingTime >= existingTime
        ? { ...existing, ...message }
        : { ...message, ...existing },
    );
  });
  return [...byId.values()].sort(
    (a, b) => new Date(a.createdAt) - new Date(b.createdAt),
  );
};

export const getDeliveryProblem = (message) => {
  if (!message.fromMe || message.isDeleted) return null;
  if (message.sendStatus === "uncertain") {
    return {
      uncertain: true,
      title: "Envio sem confirmação",
      description:
        "Confira no WhatsApp antes de reenviar para evitar duplicidade.",
    };
  }
  if (message.sendStatus !== "failed" && message.ack !== -1) return null;
  const descriptions = {
    ERR_WAPP_AUDIO_CONVERT: "Não foi possível preparar o áudio para envio.",
    ERR_WAPP_MEDIA_NOT_FOUND:
      "O arquivo não está disponível para envio. Anexe-o novamente.",
  };
  return {
    uncertain: false,
    title: "Mensagem não enviada",
    description:
      descriptions[message.sendError] ||
      "Verifique a conexão da instância antes de tentar enviar novamente.",
  };
};
